import { render, staticRenderFns } from "./sequence-review-admin-tasks.vue?vue&type=template&id=260a39c7&scoped=true"
import script from "./sequence-review-admin-tasks.vue?vue&type=script&lang=js"
export * from "./sequence-review-admin-tasks.vue?vue&type=script&lang=js"
import style0 from "./sequence-review-admin-tasks.vue?vue&type=style&index=0&id=260a39c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a39c7",
  null
  
)

export default component.exports